import React from 'react'

import { getInvite } from '../_helpers/queryParams'
import AlreadyRepliesMessage from './AlreadyRepliesMessage'
import FormReplyLoader, { useFormReply } from './_load/FormReplyLoader'

const InviteChecker = ({ children }) => {
  const hasReply = !!useFormReply()?.id
  if (hasReply) return <AlreadyRepliesMessage />

  return children
}

const Wrapper = ({ children }) => {
  const code = getInvite()
  if (!code) return children

  return (
    <FormReplyLoader>
      <InviteChecker>{children}</InviteChecker>
    </FormReplyLoader>
  )
}

export default Wrapper
